import React from 'react';
import { useShop } from '../context/ShopContext';
import { 
  X, 
  Sparkles, 
  ShieldCheck, 
  Calculator, 
  Check, 
  Lock, 
  Percent, 
  FileText,
  BadgeCheck,
  TrendingDown,
  ArrowRight
} from 'lucide-react';
import { formatINR } from '../data/products';

export const WASTAGE_CATALOG = [
  {
    category: 'Plain Gold Chains (Machine Made)',
    purity: '22KT (916 BIS)',
    marketRate: '12% - 15%',
    firstOrderRate: '4.99%',
    regularClubRate: '5.99%',
    turnaround: '24-48 Hours',
    hallmark: '100% HUID'
  },
  {
    category: 'Solid Gold Bangles & Kadas',
    purity: '22KT (916 BIS)',
    marketRate: '14% - 18%',
    firstOrderRate: '5.49%',
    regularClubRate: '6.49%',
    turnaround: 'Ready Stock',
    hallmark: '100% HUID'
  },
  {
    category: 'Die-Casting & Daily Wear Rings',
    purity: '22KT / 18KT',
    marketRate: '15% - 19%',
    firstOrderRate: '6.49%',
    regularClubRate: '7.49%',
    turnaround: '2-3 Days',
    hallmark: '100% HUID'
  },
  {
    category: 'Antique & Temple Jewellery Chokers',
    purity: '22KT (916 BIS)',
    marketRate: '18% - 24%',
    firstOrderRate: '7.99%',
    regularClubRate: '8.99%',
    turnaround: '3-5 Days',
    hallmark: '100% HUID'
  },
  {
    category: 'Kundan & Uncut Polki Bridal Sets',
    purity: '22KT / 18KT',
    marketRate: '20% - 26%',
    firstOrderRate: '8.49%',
    regularClubRate: '9.49%',
    turnaround: 'Custom Made',
    hallmark: '100% HUID'
  },
  {
    category: 'Mangalsutras & Tanmaniya Pendants',
    purity: '22KT / 18KT',
    marketRate: '14% - 18%',
    firstOrderRate: '5.99%',
    regularClubRate: '6.99%',
    turnaround: 'Ready Stock',
    hallmark: '100% HUID'
  },
  {
    category: 'Pure 24KT Gold Coins & Bullion Bars',
    purity: '24KT (999 Pure)',
    marketRate: '3.5% - 5%',
    firstOrderRate: '0.99%',
    regularClubRate: '1.49%',
    turnaround: 'Immediate Dispatch',
    hallmark: 'NABL Certified'
  },
  {
    category: 'Royal Heritage 22KT Gold Puja Idols & Artifacts',
    purity: '22KT / 24KT (916/999 BIS)',
    marketRate: '16% - 22%',
    firstOrderRate: '6.99%',
    regularClubRate: '7.99%',
    turnaround: 'Ready Stock',
    hallmark: '100% HUID Hallmarked'
  }
];

export default function WastageListModal() {
  const { 
    isWastageListOpen, 
    setIsWastageListOpen, 
    setIsWastageModalOpen,
    addToast
  } = useShop();

  if (!isWastageListOpen) return null;

  return (
    <div 
      className="modal-backdrop"
      onClick={() => setIsWastageListOpen(false)}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(8px)',
        zIndex: 1050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        overflowY: 'auto'
      }}
    >
      <div 
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'linear-gradient(145deg, #14131f 0%, #0c0b12 100%)',
          border: '1px solid var(--border-gold)',
          borderRadius: 'var(--radius-lg)',
          width: '100%',
          maxWidth: '840px',
          maxHeight: '92vh',
          overflowY: 'auto',
          boxShadow: '0 25px 60px rgba(0,0,0,0.8), 0 0 35px rgba(212,175,55,0.15)',
          color: '#fff',
          position: 'relative'
        }}
      >
        {/* Header */}
        <div style={{
          padding: '1.25rem 1.5rem',
          borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'rgba(212, 175, 55, 0.05)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '10px',
              background: 'var(--gold-gradient)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#0a0a0f'
            }}>
              <FileText size={22} />
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.45rem' }}>
                <h3 style={{ fontSize: '1.2rem', margin: 0, fontWeight: 700, color: '#fff' }}>
                  24KT Club Wastage Rate Card
                </h3>
                <span style={{
                  background: 'rgba(16, 185, 129, 0.2)',
                  border: '1px solid #10b981',
                  color: '#34d399',
                  fontSize: '0.65rem',
                  fontWeight: 800,
                  padding: '0.1rem 0.45rem',
                  borderRadius: '999px',
                  textTransform: 'uppercase'
                }}>
                  SAVE ₹20 LAKHS+
                </span>
              </div>
              <p style={{ margin: 0, fontSize: '0.78rem', color: 'var(--text-secondary)' }}>
                Bharat Ka Pehla 100% Transparent Digital Jeweller • Guaranteed Hallmark Quality
              </p>
            </div>
          </div>

          <button 
            onClick={() => setIsWastageListOpen(false)}
            style={{
              background: 'rgba(255,255,255,0.08)',
              border: 'none',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              cursor: 'pointer'
            }}
          >
            <X size={18} />
          </button>
        </div>

        {/* Modal Content */}
        <div style={{ padding: '1.5rem' }}>
          
          {/* Top Banner Notice */}
          <div style={{
            background: 'radial-gradient(ellipse at top left, rgba(212, 175, 55, 0.2) 0%, rgba(16, 185, 129, 0.1) 100%)',
            border: '1px solid var(--border-gold)',
            borderRadius: 'var(--radius-md)',
            padding: '1rem',
            marginBottom: '1.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '1rem'
          }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', color: 'var(--gold-400)', fontWeight: 700, fontSize: '0.85rem' }}>
                <Sparkles size={16} /> First-Time Member Bonus Active
              </div>
              <div style={{ fontSize: '0.82rem', color: '#e2e8f0', marginTop: '2px' }}>
                Enjoy <strong>Discounted Introductory Wastage</strong> on your very first order. Regular member wastage applies thereafter.
              </div>
            </div>

            <button
              onClick={() => {
                setIsWastageListOpen(false);
                setIsWastageModalOpen(true);
              }}
              style={{
                background: 'var(--gold-gradient)',
                color: '#000',
                border: 'none',
                borderRadius: 'var(--radius-sm)',
                padding: '0.55rem 1rem',
                fontSize: '0.8rem',
                fontWeight: 800,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.35rem'
              }}
            >
              <Calculator size={15} /> Calculate Savings
            </button>
          </div>

          {/* Table */}
          <div style={{ overflowX: 'auto', marginBottom: '1.5rem' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem' }}>
              <thead>
                <tr style={{ background: 'rgba(255,255,255,0.06)', borderBottom: '1px solid rgba(212, 175, 55, 0.3)' }}>
                  <th style={{ padding: '0.75rem 0.85rem', textAlign: 'left', color: 'var(--gold-300)', fontWeight: 700 }}>Jewellery Category</th>
                  <th style={{ padding: '0.75rem 0.85rem', textAlign: 'left', color: 'var(--gold-300)', fontWeight: 700 }}>Purity</th>
                  <th style={{ padding: '0.75rem 0.85rem', textAlign: 'center', color: '#fb7185', fontWeight: 600 }}>Market Wastage</th>
                  <th style={{ padding: '0.75rem 0.85rem', textAlign: 'center', color: 'var(--gold-400)', fontWeight: 800 }}>First-Time Offer</th>
                  <th style={{ padding: '0.75rem 0.85rem', textAlign: 'center', color: '#34d399', fontWeight: 800 }}>24KT Club Wastage</th>
                  <th style={{ padding: '0.75rem 0.85rem', textAlign: 'center', color: '#cbd5e1' }}>Hallmark</th>
                </tr>
              </thead>
              <tbody>
                {WASTAGE_CATALOG.map((item, idx) => (
                  <tr 
                    key={idx}
                    style={{
                      borderBottom: '1px solid rgba(255,255,255,0.05)',
                      background: idx % 2 === 0 ? 'rgba(255,255,255,0.015)' : 'transparent'
                    }}
                  >
                    <td style={{ padding: '0.75rem 0.85rem', fontWeight: 600, color: '#fff' }}>
                      {item.category}
                    </td>
                    <td style={{ padding: '0.75rem 0.85rem', color: 'var(--text-secondary)' }}>
                      {item.purity}
                    </td>
                    <td style={{ padding: '0.75rem 0.85rem', textAlign: 'center', color: '#a1a1aa', textDecoration: 'line-through' }}>
                      {item.marketRate}
                    </td>
                    <td style={{ padding: '0.75rem 0.85rem', textAlign: 'center' }}>
                      <span style={{
                        background: 'rgba(212, 175, 55, 0.15)',
                        border: '1px solid var(--border-gold)',
                        color: 'var(--gold-300)',
                        padding: '0.2rem 0.5rem',
                        borderRadius: '4px',
                        fontWeight: 700
                      }}>
                        {item.firstOrderRate}
                      </span>
                    </td>
                    <td style={{ padding: '0.75rem 0.85rem', textAlign: 'center' }}>
                      <span style={{
                        background: 'rgba(16, 185, 129, 0.15)',
                        border: '1px solid #10b981',
                        color: '#34d399',
                        padding: '0.2rem 0.5rem',
                        borderRadius: '4px',
                        fontWeight: 800
                      }}>
                        {item.regularClubRate}
                      </span>
                    </td>
                    <td style={{ padding: '0.75rem 0.85rem', textAlign: 'center' }}>
                      <span style={{ fontSize: '0.72rem', color: '#93c5fd', display: 'inline-flex', alignItems: 'center', gap: '0.2rem' }}>
                        <ShieldCheck size={13} /> {item.hallmark}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Bottom Trust & Join Club CTA */}
          <div style={{
            background: 'rgba(255,255,255,0.03)',
            borderRadius: 'var(--radius-md)',
            border: '1px solid rgba(255,255,255,0.08)',
            padding: '1.2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '1rem'
          }}>
            <div>
              <div style={{ fontSize: '0.92rem', fontWeight: 700, color: '#fff' }}>
                Are you a Jeweller, Wholesaler or Bulk Buyer?
              </div>
              <div style={{ fontSize: '0.78rem', color: 'var(--text-secondary)' }}>
                Calculate precise making charges, wastage, and 3% GST on any custom ornament weight.
              </div>
            </div>

            <div style={{ display: 'flex', gap: '0.6rem' }}>
              <button
                onClick={() => {
                  setIsWastageListOpen(false);
                  window.location.hash = '#/calculator';
                }}
                style={{
                  background: 'var(--gold-gradient)',
                  color: '#0a0a0f',
                  border: 'none',
                  borderRadius: 'var(--radius-sm)',
                  padding: '0.65rem 1.1rem',
                  fontSize: '0.82rem',
                  fontWeight: 800,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.4rem'
                }}
              >
                Open Price Calculator <ArrowRight size={15} />
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
